
<div class="header-toolbar">
  <h1>
    {{ entity?.name }}
    <span>version {{ entity?.version }}</span>
  </h1>
</div>


<div *ngIf="entity">

  <!-- Toolbar -->
  <div class="main btn-toolbar">

    <div class="btn-group">    
      <div class="content">

      <a class="btn" *ngIf="entity.hasMovements" [routerLink]="['movements-ledger']">
        <t-icon name="seal_check"></t-icon>
        <span class="text">Registre des mouvements</span>
      </a>

      </div>
    </div>

    <div class="btn-group">    
      <div class="content">

        <a class="btn" [routerLink]="'..'">
          <t-icon name="close"></t-icon>
          <span class="text">Annuler</span>
        </a>

      </div>
    </div>

  </div>
  <!-- /Toolbar -->

  <div class="grid" *ngIf="entity">

    <div class="column">
      
      <sl-entity-infos [entity]="entity"></sl-entity-infos>

      <sl-entity-blockchain [entity]="entity"></sl-entity-blockchain>

      <sl-entity-details [entity]="entity"></sl-entity-details>
      
    </div>
    
    <div class="column">
      <sl-entity-movements [entity]="entity"></sl-entity-movements>

    </div>

  </div>
</div>